import { FC } from 'react';

import { OrgLogo } from '@crossnokaye/ux-animatics';

import { analytics } from '@/analytics/analytics-service';
import { FloatingDraggable } from '@/components/floating-draggable/floating-draggable';
import { buildDarkwingUrl } from '@/components/navigation/utils';
import { hasMigrationRouteFeatureFlag } from '@/config/route-feature-flags';
import { FEATURE_FLAGS } from '@/constants';
import { useCurrentFacility } from '@/hooks/use-current-facility';
import { useCurrentRoute } from '@/hooks/use-current-route';
import { useFeatureFlag } from '@/hooks/use-feature-flag';

export const BetaCompareButton: FC = () => {
  const { facilityUrlName, orgUrlName } = useCurrentFacility();
  const currentRoute = useCurrentRoute();
  const isEnabled = useFeatureFlag(FEATURE_FLAGS.GAIA_BETA_TOOLS);

  // Hide if feature flag disabled or if current route is not a Darkwing-comparable migration route
  if (!isEnabled) return null;
  if (currentRoute && !hasMigrationRouteFeatureFlag(currentRoute)) return null;

  const handleClick = () => {
    // Track event
    analytics.track('Beta UI Reverted', {
      'Current Route': currentRoute,
    });

    // Use the current route directly (already extracted by useCurrentRoute)
    const feature = currentRoute || 'equipment';
    // Build proper Darkwing URL if we have facility info
    if (orgUrlName && facilityUrlName) {
      const url = `${buildDarkwingUrl(orgUrlName, facilityUrlName, feature)}?beta-compare=true`;
      window.open(url, '_blank');
    } else {
      console.warn('Beta compare button: Unable to determine org or facility name');
    }
  };

  return (
    <FloatingDraggable storageKey="beta-compare-button-position">
      <button
        className="flex items-center justify-center lg:w-12 lg:h-12 w-10 h-10 rounded-full bg-warning shadow-lg hover:shadow-xl ring-2 ring-warning/100 hover:ring-warning/20 transition-all duration-200 hover:scale-110"
        onClick={handleClick}
        aria-label="Compare with Darkwing"
      >
        <OrgLogo
          symbol="crossnokaye"
          size="1.25rem"
          className="text-background bg-warning"
          color="black"
        />
      </button>
    </FloatingDraggable>
  );
};
